export type StatementDetailsProps = {
    statement: Statement;
};

export type InvoiceDetails = {
    createdAt: Date;
    id: number;
    merchant: {
        id: number;
        legalName: string;
    };
    partner: {
        id: number;
        legalName: string;
    };
};

export type InvoiceHistoryProps = {
    invoices: InvoiceDetails[];
    commissionItemsInvoice: any;
};

export enum StatementStatus {
    PAID = 'Paid',
    PARTIALLYPAID = 'Partially Paid',
    UNPAID = 'Unpaid',
}

export type StatementStatusType = (typeof StatementStatus)[keyof typeof StatementStatus];

export type StatementDetails = {
    partnerName: string;
    statementId: string;
    statementStatus: StatementStatusType;
};

export type CommissionStatementTotals = {
    totalSetupAndAccessory: number;
    totalMonthly: number;
    totalCommission: number;
};

export type CommissionItemsProps = {
    commissionItems: CommissionItem[];
    commissionType: string;
    commissionTypeHeading: string;
};

export type Commission = {
    id: number;
    partnerName: string;
    partnerType: string;
    commissionItem: CommissionItem[];
};

export type CommissionItem = {
    merchantId: number;
    merchant: string;
    serviceActivationDate?: Date;
    setupAndAccessory: number;
    monthly: number;
    commission: number;
};

export type CommissionStatementDetails = {
    statementDetails: StatementDetails;
    billingDetails: BillingDetails;
    totals: CommissionStatementTotals;
    commissionItems: Commission[];
};
